import React, { Component } from 'react';
import { connect } from 'react-redux';
import { publishActions } from '../actions/publishActions';
import MathJax from 'react-mathjax-preview';

export class UserQuestionGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hoverImageUrl: "",
            cssClass: "modal",
            currentSubject: {}
        }

        this.redirectToEditQuesForm = this.redirectToEditQuesForm.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);
        this.prevRecords = this.prevRecords.bind(this);
        this.nextRecords = this.nextRecords.bind(this);
        this.showLargeImage = this.showLargeImage.bind(this);
        this.hideLargeImage = this.hideLargeImage.bind(this);
    }

    redirectToEditQuesForm(e) {
        var id = e.currentTarget.getAttribute('data-id');
        let quesData = {};
        this.props.searchResult.forEach((item) => {
            if (item._id == id) {
                quesData = item;
            }
        });

        this.props.handleEditQuestionForm(id, quesData);
    }
    prevRecords() {
        var params = this.props.selectedFilter;
        params.page -= 1;
        this.props.searchQuestions(params);
    }
    nextRecords() {
        var params = this.props.selectedFilter;
        params.page += 1;
        this.props.searchQuestions(params);
    }
    showLargeImage(e) {
        var srcImage = e.currentTarget.getAttribute("data-src");
        this.setState({
            hoverImageUrl: srcImage,
            cssClass: "modal imageModal"
        })
    }
    hideLargeImage(e) {
        this.setState({
            hoverImageUrl: '',
            cssClass: "modal"
        })
    }
    downloadCSV() {
        this.props.downloadSerchResultCSV(this.props.selectedFilter);
    }
    render() {
        const { searchResult, selectedFilter } = this.props;

        if (this.props.fetching) {
            return (
                <div className="row"><div className="col-md-5"></div>  <div className="loader col-md-2"></div></div>
            )
        } else {
            return (
                <div className="row">
                    <div className={this.state.cssClass} id="myModal" role="dialog">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <img alt="" className="modalImage" src={this.state.hoverImageUrl}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <div className="box">
                            <div className="box-header">
                                <h3 className="box-title">Check/ Update questions :</h3>
                                <button type="submit" className="btn btn-primary" onClick={this.downloadCSV}>Download CSV</button>
                            </div>
                            <div className="box-body table-responsive no-padding">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>QID</th>
                                            <th>Is Reviewed</th>
                                            <th>Staging Url</th>
                                            <th>Rating</th>
                                            <th>Question Text</th>
                                            <th>User/Expert</th>
                                            <th>Answer Text</th>
                                            <th>Subject</th>
                                            <th>Exam</th>
                                            <th>Char Length</th>
                                            <th>QC Rating</th>
                                            <th>Q Image</th>
                                            <th>A Image</th>
                                            <th>Actions</th>
                                        </tr>
                                        {searchResult.map((result, index) => (
                                            <tr key={result._id}>
                                                <td>{result._id}</td>
                                                <td>{result.isReviewed ? <i className="fa fa-check"></i> : <i className="fa fa-close"></i>}</td>
                                                <td><a href={result.stagingUrl} target="blank">Link</a></td>
                                                <td>{result.userRating}</td>
                                                <td><MathJax config={{ messageStyle: 'none' }} math={result.eng_text} /></td>
                                                <td>{result.user}</td>
                                                <td><MathJax config={{ messageStyle: 'none' }} math={result.answerText} /></td>
                                                <td>{result.subject}</td>
                                                <td>{result.exam}</td>
                                                <td>{result.eng_text ? result.eng_text.length : 0}</td>
                                                <td>{result.qcRating}</td>
                                                <td><img alt="" className="tblImage" src={result.crop_url} data-src={result.crop_url} onMouseEnter={this.showLargeImage} onMouseLeave={this.hideLargeImage}></img></td>
                                                <td><img alt="" className="tblImage" src={result.solution_url} data-src={result.solution_url} onMouseEnter={this.showLargeImage} onMouseLeave={this.hideLargeImage}></img></td>
                                                <td><button className="btn btn-primary" data-id={result._id} onClick={this.redirectToEditQuesForm}>Edit</button></td>
                                            </tr>
                                        ))}
                                    </tbody></table>
                            </div>
                            <div className="box-footer">
                                <div className="row">
                                    <div className="col-md-1">
                                        {/* <button type="submit" className="btn btn-primary" onClick={this.publishQuestions}>Submit</button> */}
                                    </div>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-3">
                                        {selectedFilter && selectedFilter.page > 1 ? <button type="submit" className="btn btn-default" onClick={this.prevRecords}>Prev Page</button> : ''}
                                        {selectedFilter && selectedFilter.page > 0 ? <button type="submit" className="btn btn-default" onClick={this.nextRecords}>Next Page</button> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    const { searchResult, selectedFilter } = state.publish;
    const { fetching } = state.notification;
    return {
        searchResult,
        selectedFilter,
        fetching
    };
};

const actionCreators = { searchQuestions: publishActions.searchQuestions, downloadSerchResultCSV: publishActions.downloadSerchResultCSV }

export default connect(mapStateToProps, actionCreators)(UserQuestionGrid);
